export const category = {
  categoryName: "",
  description: "",
  displayOrder: 999,
};
